export default "__VITE_ASSET__plUESXI4__"